export const sharedTileButtonClass = 'min-w-[44px]';
